export const deAccessDenied = {
  'accessDenied.title': 'Zugriff verweigert',
  'accessDenied.description1':
    'Sie haben aktuell keinen Zugriff auf diese Applikation. \nUm fortzufahren, benötigen Sie die entsprechenden Berechtigungen und eine gültige Benutzerrolle.',
  'accessDenied.description2':
    'Bitte wenden Sie sich an Ihre Ansprechperson oder nutzen Sie den internen Prozess zur Beantragung des Zugriffs.',
  'accessDenied.footer.description': 'Supported by',
};
